import Cookies from 'js-cookie';

const Logout = () => {
    Cookies.remove('token');
    window.location.href = '/login'
}

export default Logout;
